<template>
  <v-dialog
    scrollable
    v-model="visible"
    max-width="900px"
    :fullscreen="fullscreen"
    :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
        <v-tabs
          slot="extension"
          centered
          v-model="tab"
          color="transparent"
        >
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab href="#tab-empl" ripple v-if="showEmpl">校内成员</v-tab>
          <v-tab href="#tab-not-empl" ripple v-if="showNotEmpl">校外成员</v-tab>
        </v-tabs>
      </v-toolbar>
      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-form v-model="formValid" ref="formRef" lazy-validation>
          <v-tabs-items v-model="tab">
            <v-tab-item value="tab-empl" v-if="showEmpl">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs2>
                    <v-select
                      label="排序"
                      v-model="item.rank"
                      :items="validRanks"
                      :rules="rules.emplRequired"
                    />
                  </v-flex>
                  <v-flex xs10>
                    <x-syst-user-select
                      label="校内成员"
                      :rules="rules.emplRequired"
                      v-model="user"
                      hint="输入关键词，检索添加校内在职人员。"
                      persistent-hint
                      v-if="tab === 'tab-empl'"
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-tab-item>
            <v-tab-item value="tab-not-empl" v-if="showNotEmpl">
              <v-container grid-list-md>
                <v-layout wrap>

                  <v-flex xs2>
                    <v-select
                      label="排序"
                      v-model="item.rank"
                      :items="validRanks"
                      :rules="rules.notEmplRequired"
                    />
                  </v-flex>

                  <v-flex xs3>
                    <v-text-field
                      label="姓名"
                      :rules="rules.notEmplRequired"
                      v-model="item.name"/>
                  </v-flex>

                  <v-flex xs7>
                    <v-text-field
                      label="单位名称"
                      :rules="rules.notEmplRequired"
                      v-model="item.deptName"/>
                  </v-flex>

                  <v-flex xs2>
                    <v-autocomplete
                      label="性别"
                      v-model="item.sex"
                      clearable
                      :items="['男', '女']"
                    />
                  </v-flex>

                  <v-flex xs2>
                    <v-text-field
                      label="年龄"
                      :rules="rules.age"
                      clearable
                      v-model="item.age"
                    />
                  </v-flex>

                  <v-flex xs4>
                    <v-autocomplete
                      label="职称"
                      v-model="item.titleId"
                      clearable
                      :items="titleItems"
                      item-value="dbid"
                      item-text="name"
                    />
                  </v-flex>

                  <v-flex xs4>
                    <v-autocomplete
                      label="学位"
                      v-model="item.educId"
                      clearable
                      :items="educItems"
                      item-value="dbid"
                      item-text="name"
                    />
                  </v-flex>

                </v-layout>
              </v-container>
            </v-tab-item>
          </v-tabs-items>
        </v-form>

      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>
        <v-btn color="primary" @click.native="onSave">保存
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

  import mixin from '@/mixin'
  import XSystUserSelect from '@/components/global/SystUserSelectExt'

  const baseURI = '/api/proj/member';
  const titleURI = '/api/code/title';
  const educURI = '/api/code/education';

  export default {
    mixins: [mixin.edit(baseURI)],
    props: ['value', 'uri', "dbid", 'projectId', 'validRanks'],
    components: {XSystUserSelect},

    data() {
      return {
        formValid: false,

        tab: 'tab-empl',

        item: {},
        freshItem: {
          projectId: null,
          userId: null,
          name: null,
          sex: null,
          age: null,
          titleId: null,
          educId: null,
          deptId: null,
          deptName: null,

          rank: null,
        },

        user: {},

        titleItems: [],
        educItems: [],

        showEmpl: true,
        showNotEmpl: true,

        /**
         * 验证规则
         */
        rules: {
          emplRequired: [
            v => ((this.tab === 'tab-not-empl') || !!v) || '必填项。'
          ],
          notEmplRequired: [
            v => ((this.tab === 'tab-empl') || !!v) || '必填项。'
          ],
          age: [
            v => (!v || /^[1-9]\d?$/.test(v)) || '请填写 10〜99的整数。'
          ]
        }
      }
    },

    beforeMount() {
      this.axios.all([
        this.axios.get(titleURI, {params: {limit: 65535, disabled: 'F'}}),
        this.axios.get(educURI, {params: {limit: 65535, disabled: 'F'}}),
      ]).then(
        this.axios.spread(
          (rspTitl, rspEduc) => {
            this.titleItems = rspTitl.data.items;
            this.educItems = rspEduc.data.items;
          }
        )
      )
    },

    watch: {
      tab() {
        const r = this.item.rank;
        this.item = window.xutil.clone(this.freshItem);
        this.item.rank = r;
      },
      user(u) {
        if (u) {
          Object.assign(
            this.item,
            {
              userId: u.dbid,
              name: u.name,
              sex: u.sex,
              age: u.birthday ? (new Date(new Date() - new Date(u.birthday)).getFullYear() - 1970) : null,
              titleId: u.title ? u.title.dbid : null,
              degreeId: u.degree ? u.degree.dbid : null,
              deptId: u.deptRoles ? u.deptRoles[0].department.dbid : null,
              deptName: u.deptRoles ? u.deptRoles[0].department.name : null,
            }
          );
        }
      },
      validRanks(v) {
        if (v) {
          this.item.rank = v ? v[0] : 1;
        }
      },
      dbid(v) {
        if (!v) {
          this.showEmpl = true;
          this.showNotEmpl = true;
        }
      }
    },

    methods: {
      // mixin 加载数据后调用
      afterGetData(data) {
        // window.console.log("in Edit afterGetData");
        if (data.userId) {
          this.showEmpl = true;
          this.showNotEmpl = false;
          this.user = {
            userId: data.userId,
            name: data.name
          }
        } else {
          this.showEmpl = false;
          this.showNotEmpl = true;
        }
      },

      beforeSendData(data) {
        //console.log("in beforeSendData");
        data.projectId = this.projectId;
      }
    }
  }
</script>
